import React from "react";
import PropTypes from "prop-types";

import {
  Row,
  Form,
  Button,
  Col,
  DatePicker,
  Select,
  Divider,
  Space,
  InputNumber,
} from "antd";
import dayjs from "dayjs";

import GenericCard from "components/UI/GenericCard/GenericCard";
import { modelSearchRangePresets } from "utils/constants";

import { useSelector } from "react-redux";

const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YY";

const SavePredictionsForm = (props) => {
  const { form } = props;

  const symbolsGroupedInSectored = useSelector(
    (state) => state.main.symbolsGroupedInSectored
  );

  const symbolsList = useSelector((state) => state.main.symbolsList);

  const handleSelectAll = (type) => {
    const symbols = symbolsList.map((symbol) => symbol.ticker);
    form.setFieldValue("symbols", symbols);
  };

  return (
    <GenericCard title="Predict with AI">
      <Form
        form={form}
        layout="vertical"
        name="ai"
        initialValues={{
          dates: [dayjs("2000-01-01"), dayjs().add(1, "d")],
          symbols: [],
          maxWorkers: 1,
        }}
        style={{
          maxWidth: 400,
        }}
      >
        <Row gutter={5} align="bottom">
          <Col xs={24} sm={24}>
            <Form.Item name="dates" label="Dates">
              <RangePicker
                presets={modelSearchRangePresets}
                format={dateFormat}
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item
              name="symbols"
              label="Symbol"
              required={false}
              rules={[
                {
                  required: true,
                  message: "Select at least one symbol",
                },
              ]}
            >
              <Select
                placeholder="Select symbols"
                mode="multiple"
                options={symbolsGroupedInSectored}
                style={{
                  width: "100%",
                }}
                filterOption={(inputValue, option) =>
                  option.label
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                optionLabelProp="value"
                maxTagCount="responsive"
                allowClear
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider
                      orientation="left"
                      style={{
                        margin: "8px 0",
                        fontSize: "14px",
                      }}
                    >
                      Select groups
                    </Divider>
                    <Space
                      style={{
                        padding: "0 8px 4px",
                      }}
                    >
                      <Button
                        type="text"
                        // icon={<PlusOutlined />}
                        onClick={() => handleSelectAll()}
                      >
                        All
                      </Button>
                    </Space>
                  </>
                )}
              />
            </Form.Item>
          </Col>
          <Form.Item
            name="maxWorkers"
            label="Max Workers"
            required={false}
            rules={[
              {
                required: true,
                message: "Please enter the number of workers",
              },
            ]}
          >
            <InputNumber min={1} max={20} />
          </Form.Item>
        </Row>
      </Form>
    </GenericCard>
  );
};

SavePredictionsForm.propTypes = {
  form: PropTypes.any,
};

export default SavePredictionsForm;
